import styled from 'styled-components'

export const CommandStatusTagWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  /* 标签样式 */
  .ant-tag {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    border: 1px solid transparent !important;
    border-radius: 20px !important;

    padding: 4px 12px !important;
    margin: 0 !important;
    box-sizing: border-box;

    cursor: default;

    >span.ant-tag-status-text {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      padding: 0;
      box-sizing: border-box;

      font-size:  var(--fontsize-14);
      letter-spacing: var(--spacing-large);
      line-height: 1;
    }

    /* 未新增（本地新增行，尚未同步） */
    &.tag-pending-new {
      color: #08979C;
      background: rgba(8, 151, 156, 0.12);
    }
    /* 修改中 */
    &.tag-editing {
      color: var(--editing-color);
      background: var(--editing-light-color);
    }
    /* 新增项 */
    &.tag-adding {
      color: var(--adding-color);
      background: var(--adding-light-color);
    }
    /* 等待发送 */
    &.tag-waiting {
      color: var(--waiting-color);
      background: var(--waiting-light-color);
    }
    /* 同步中 */
    &.tag-syncing {
      color: var(--syncing-color);
      background: var(--syncing-light-color);
    }
    /* 正常 */
    &.tag-normal {
      color: var(--normal-color);
      background: var(--normal-light-color);
    }
    /* 超时 */
    &.tag-timeout {
      color: var(--timeout-color);
      background: var(--timeout-light-color);
    }
    /* 错误 */
    &.tag-error {
      color: var(--error-color);
      background: var(--error-light-color);
    }
  }

  &.chCsTag {
    .ant-tag {
      min-width: calc(73px - var(--spacing-large));
      >span.ant-tag-status-text {
        letter-spacing: var(--spacing-large);
      }
    }
  }

  &.jpCsTag {
    .ant-tag {
      min-width: calc(98px - var(--spacing-normal));
      >span.ant-tag-status-text {
        letter-spacing: var(--spacing-normal);
      }
    }
  }

  &.enCsTag {
    .ant-tag {
      min-width: calc(73px - var(--spacing-normal));
      >span.ant-tag-status-text {
        letter-spacing: var(--spacing-normal);
      }
    }
  }
`

export const DeviceStatusTagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 100%;

  .ant-tag {
    margin-right: 0;
    padding: 0;
    white-space: nowrap;
    background: transparent;
    border: none;

    /* 离线 */
    &.deviceOffline {
      >.ant-tag-status-text {
        color: var(--deviceOffline-color);
        font-size: var(--fontsize-14);
      }
   }
   
    /* 故障 */
    &.failure {
      >.ant-tag-status-text {
        color: var(--failure-color);
        font-size: var(--fontsize-14);
      }
   }

    /* 停机 */
    &.shutDown {
      >.ant-tag-status-text {
        color: var(--shutDown-color);
        font-size: var(--fontsize-14);
      }
   }

    /* 正常 */
    &.normal {
      >.ant-tag-status-text {
        color: var(--normal-color);
        font-size: var(--fontsize-14);
      }
   }

    /* 灰色 —— 通讯异常 */
    &.commInterruption {
      >.ant-tag-status-text {
        color: var(--commInterruption-color); /* 灰色 */
        font-size: var(--fontsize-14);
      }
    }

    /* 紫色 —— 阈值警报 */
    &.thresholdAlarm {
      >.ant-tag-status-text {
        color: var(--thresholdAlarm-color); /* 紫色 */
        font-size: var(--fontsize-14);
      }
    }
  }

  .ant-badge-status-text {
    margin-left: 6px;
  }

  .ant-badge-status-dot {
    /* 状态点动画 */
    &.ant-badge-status-commInterruption::after,
    &.ant-badge-status-thresholdAlarm::after,
    &.ant-badge-status-normal::after,
    &.ant-badge-status-deviceOffline::after,
    &.ant-badge-status-failure::after,
    &.ant-badge-status-shutDown::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      animation: antStatusProcessing 1.2s infinite ease-in-out;
      content: '';
    }

    /* 离线 */
    &.ant-badge-status-deviceOffline {
      background-color: var(--deviceOffline-color);
      &::after {
        border: 2px solid var(--deviceOffline-color);
      }
    }

    /* 故障 */
    &.ant-badge-status-failure {
      background-color: var(--failure-color);
      &::after {
        border: 2px solid var(--failure-color);
      }
    }

    /* 停机 */
    &.ant-badge-status-shutDown {
      background-color: var(--shutDown-color);
      &::after {
        border: 2px solid var(--shutDown-color);
      }
    }

    /* 正常 */
    &.ant-badge-status-normal {
      background-color: var(--normal-color);
      &::after {
        border: 2px solid var(--normal-color);
      }
    }

    &.ant-badge-status-commInterruption {
      background-color: var(--commInterruption-color);
      &::after {
        border: 2px solid var(--commInterruption-color);
      }
    }

    &.ant-badge-status-thresholdAlarm {
      background-color: var(--thresholdAlarm-color);
      &::after {
        border: 2px solid var(--thresholdAlarm-color);
      }
    }
  }

  &.tagLink .ant-badge {
    padding: 0 12px !important;
    border: 1px solid var(--sky-0);
    border-radius: 24px !important;
    min-width: var(--wh-88);
    line-height: 1.5715 !important;
    cursor: pointer !important;
    &:hover {
      border: 1px solid var(--sky-25);
      background: var(--white-100);
      box-shadow: 0 0 8px var(--sky-5);
    }

    .ant-badge-status-dot {
      top: -2px !important
    }
  }
`

export const ProcessingStatusTagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 100%;

  .ant-tag {
    margin-right: 0;
    padding: 0;
    white-space: nowrap;
    background: transparent;
    border: none;

    /* 故障 */
    &.failure {
      >.ant-tag-status-text {
        color: var(--failure-color);
        font-size: var(--fontsize-14);
      }
   }

    /* 正常 */
    &.normal {
      >.ant-tag-status-text {
        color: var(--normal-color);
        font-size: var(--fontsize-14);
      }
   }
  }

  .ant-badge-status-text {
    margin-left: 6px;
  }

  .ant-badge-status-dot {
    /* 状态点动画 */
    &.ant-badge-status-normal::after,
    &.ant-badge-status-failure::after,
    &.ant-badge-status-deviceOffline::after,
    &.ant-badge-status-commInterruption::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      animation: antStatusProcessing 1.2s infinite ease-in-out;
      content: '';
    }

    /* 故障 */
    &.ant-badge-status-failure {
      background-color: var(--failure-color);
      &::after {
        border: 2px solid var(--failure-color);
      }
    }

    /* 离线 */
    &.ant-badge-status-deviceOffline {
      background-color: var(--deviceOffline-color);
      &::after {
        border: 2px solid var(--deviceOffline-color);
      }
    }
    /* 通讯异常 */
    &.ant-badge-status-commInterruption {
      background-color: var(--commInterruption-color);
      &::after {
        border: 2px solid var(--commInterruption-color);
      }
    }

    /* 正常 */
    &.ant-badge-status-normal {
      background-color: var(--normal-color);
      &::after {
        border: 2px solid var(--normal-color);
      }
    }
  }

  &.tagLink .ant-badge {
    padding: 0 12px !important;
    border: 1px solid var(--sky-0);
    border-radius: 24px !important;
    min-width: var(--wh-88);
    line-height: 1.5715 !important;
    cursor: pointer !important;
    &:hover {
      border: 1px solid var(--sky-25);
      background: var(--white-100);
      box-shadow: 0 0 8px var(--sky-5);
    }

    .ant-badge-status-dot {
      top: -2px !important
    }
  }

  .ant-badge-status-dot.ant-badge-status-failure,
  .ant-badge-status-dot.ant-badge-status-normal,
  .ant-badge-status-dot.ant-badge-status-deviceOffline, 
  .ant-badge-status-dot.ant-badge-status-commInterruption {
  width: 10px !important;
  height: 10px !important;
}
`


export const WithIconTagWrapper = styled.div`
  width: fit-content;
`

export const TextTagWrapper = styled.div`
  width: fit-content;
`

export const AlarmTypeTagWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .ant-badge {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: default;
  }

  .ant-badge-status-text {
    margin-left: 6px;
    letter-spacing: var(--spacing-large);
  }

  .ant-badge-status-dot {
    /* 状态点动画 */
    &.ant-badge-status-offline::after,
    &.ant-badge-status-failure::after,
    &.ant-badge-status-commInterruption::after,
    &.ant-badge-status-thresholdAlarm::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      animation: antStatusProcessing 1.2s infinite ease-in-out;
      content: '';
    }

    /* 离线 */
    &.ant-badge-status-offline {
      background-color: var(--offline-color);
      &::after {
        border: 2px solid var(--offline-color);
      }
    }

    /* 故障 */
    &.ant-badge-status-failure {
      background-color: var(--failure-color);
      &::after {
        border: 2px solid var(--failure-color);
      }
    }

    /* 通讯异常 */
    &.ant-badge-status-commInterruption {
      background-color: var(--commInterruption-color);
      &::after {
        border: 2px solid var(--commInterruption-color);
      }
    }

    /* 阈值报警 */
    &.ant-badge-status-thresholdAlarm {
      background-color: var(--thresholdAlarm-color);
      &::after {
        border: 2px solid var(--thresholdAlarm-color);
      }
    }
  }

  &.tagLink .ant-badge {
    padding: 0 12px !important;
    border: 1px solid var(--sky-0);
    border-radius: 24px !important;
    min-width: var(--wh-88);
    line-height: 1.5715 !important;
    cursor: pointer !important;
    &:hover {
      border: 1px solid var(--sky-25);
      background: var(--white-100);
      box-shadow: 0 0 8px var(--sky-5);
    }

    .ant-badge-status-dot {
      top: -2px !important
    }
  }

  &.tagNumberLink .ant-badge {
    line-height: 1.4712 !important;
    transition: var(--transition-faster);
    cursor: pointer;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;

    border: 1px solid var(--sky-0);
    min-height: 24px;
    border-radius: 24px;

    >span.ant-badge-status-dot {
      top: 0px;
    }

    >span.ant-badge-status-text {
      .ant-space {
        gap: 4px !important;
        .ant-space-item {
          &:first-child {
            .ant-typography {
              font-size: var(--fontsize-12);
            }
          }
          &:last-child {
            .ant-typography {
              font-family: 'Arial Narrow';
              font-size: var(--fontsize-12);
              font-weight: var(--fontweight-600);
              color: var(--font-85);
            }
          }
        }
      }
    }

    &:hover {
      padding: 0 8px;

      border-color: var(--sky-5);
      background: var(--white-100);
	    box-shadow: 0 0 0 4px var(--sky-light-285);

      transform: var(--size-large);

      .ant-badge-status-text .ant-typography {
        color: var(--font-85);
      }
    }

    @media (max-width: 1300px) {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      min-width: 28px;
      .ant-badge-status-dot {
        top: 0;
      }
      .ant-badge-status-text {
        .ant-space {
          gap: 0 !important;
          .ant-space-item {
            &:first-child {
              width: 0 !important;
              height: 24px !important;
              opacity: 0;
              transform: var(--size-none) !important;
            }
            &:last-child {}
          }
        }
      }
    }
    @media (max-width: 576px) {
      justify-content: center;

      width: fit-content;
      min-width: 0;
      height: 24px;
      .ant-badge-status-text {
        padding: 0;
        margin: 0;
        width: 0;
        opacity: 0;
        transform: var(--size-none);
      }
    }
  }
`

/* 报警类型状态标签组 */
export const TagAtCard = styled.div`
  transform: var(--size-small);
  .ant-typography {
    font-family: 'Arial Narrow';
    font-size: var(--fontsize-12);
    line-height: 1;
  }
  .ant-divider {
    >.ant-divider-inner-text {
      font-size: var(--fontsize-14);
    }
  }
`
export const TagAtOfflineCard = styled.div`
`
export const TagAtFailureCard = styled.div`
`
export const TagAtDisconnectionCard = styled.div`
`
export const TagAtThresholdDiyCard = styled.div`
`

/* 命令状态标签组 */
export const TagCsCard = styled.div`
  transform: var(--size-small);
  .ant-typography {
    font-family: 'Arial Narrow';
    font-size: var(--fontsize-12);
    line-height: 1;
  }
  .ant-divider {
    >.ant-divider-inner-text {
      font-size: var(--fontsize-14);
    }
  }
`
export const TagCsEditingCard = styled.div`
`
export const TagCsAddingCard = styled.div`
`
export const TagCsWaitingCard = styled.div`
`
export const TagCsSyncingCard = styled.div`
`
export const TagCsNormalCard = styled.div`
`
export const TagCsTimeoutCard = styled.div`
`
export const TagCsErrorCard = styled.div`
`

/* 设备状态标签组 */
export const TagDsCard = styled.div`
  transform: var(--size-small);
  .ant-typography {
    font-family: 'Arial Narrow';
    font-size: var(--fontsize-12);
    line-height: 1;
  }
  .ant-divider {
    >.ant-divider-inner-text {
      font-size: var(--fontsize-14);
    }
  }
`
export const TagDsDeviceOfflineCard = styled.div`
`
export const TagDsFailureCard = styled.div`
`
export const TagDsShutdownCard = styled.div`
`
export const TagDsNormalCard = styled.div`
`

export const PsStatusTagWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .ant-badge {
    cursor: default;
  }

  .ant-badge-status-text {
    margin-left: 6px;
    letter-spacing: var(--spacing-large);
  }

  .ant-badge-status-dot {
    /* 状态点动画 */
    &.ant-badge-status-loggerOffline::after,
    &.ant-badge-status-emergencyStop::after,
    &.ant-badge-status-failure::after,
    &.ant-badge-status-deviceOffline::after,
    &.ant-badge-status-shutDown::after,
    &.ant-badge-status-partShutDown::after,
    &.ant-badge-status-normal::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      animation: antStatusProcessing 1.2s infinite ease-in-out;
      content: '';
    }

    /* 通讯异常 */
    &.ant-badge-status-loggerOffline {
      background-color: var(--loggerOffline-color);
      &::after {
        border: 2px solid var(--loggerOffline-color);
      }
    }

    /* 紧急停止 */
    &.ant-badge-status-emergencyStop {
      background-color: var(--emergencyStop-color);
      &::after {
        border: 2px solid var(--emergencyStop-color);
      }
    }

    /* 故障 */
    &.ant-badge-status-failure {
      background-color: var(--failure-color);
      &::after {
        border: 2px solid var(--failure-color);
      }
    }

    /* 设备离线 */
    &.ant-badge-status-deviceOffline {
      background-color: var(--deviceOffline-color);
      &::after {
        border: 2px solid var(--deviceOffline-color);
      }
    }

    /* 停机 */
    &.ant-badge-status-shutDown {
      background-color: var(--shutDown-color);
      &::after {
        border: 2px solid var(--shutDown-color);
      }
    }

    /* 部分停机 */
    &.ant-badge-status-partShutDown {
      background-color: var(--partShutDown-color);
      &::after {
        border: 2px solid var(--partShutDown-color);
      }
    }
    
    /* 正常 */
    &.ant-badge-status-normal {
      background-color: var(--normal-color);
      &::after {
        border: 2px solid var(--normal-color);
      }
    }
  }
`

export const TotalSystemTagWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .ant-badge {
    cursor: default;
  }

  .ant-badge-status-text {
    margin-left: 6px;
    letter-spacing: var(--spacing-large);
  }

  .ant-badge-status-dot {
    /* 状态点动画 */
    &.ant-badge-status-loggerOffline::after,
    &.ant-badge-status-emergencyStop::after,
    &.ant-badge-status-failure::after,
    &.ant-badge-status-deviceOffline::after,
    &.ant-badge-status-shutDown::after,
    &.ant-badge-status-partShutDown::after,
    &.ant-badge-status-normal::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      animation: antStatusProcessing 1.2s infinite ease-in-out;
      content: '';
    }

    /* 通讯异常 */
    &.ant-badge-status-loggerOffline {
      background-color: var(--loggerOffline-color);
      &::after {
        border: 2px solid var(--loggerOffline-color);
      }
    }

    /* 紧急停止 */
    &.ant-badge-status-emergencyStop {
      background-color: var(--emergencyStop-color);
      &::after {
        border: 2px solid var(--emergencyStop-color);
      }
    }

    /* 故障 */
    &.ant-badge-status-failure {
      background-color: var(--failure-color);
      &::after {
        border: 2px solid var(--failure-color);
      }
    }

    /* 设备离线 */
    &.ant-badge-status-deviceOffline {
      background-color: var(--deviceOffline-color);
      &::after {
        border: 2px solid var(--deviceOffline-color);
      }
    }

    /* 停机 */
    &.ant-badge-status-shutDown {
      background-color: var(--shutDown-color);
      &::after {
        border: 2px solid var(--shutDown-color);
      }
    }

    /* 部分停机 */
    &.ant-badge-status-partShutDown {
      background-color: var(--partShutDown-color);
      &::after {
        border: 2px solid var(--partShutDown-color);
      }
    }
    
    /* 正常 */
    &.ant-badge-status-normal {
      background-color: var(--normal-color);
      &::after {
        border: 2px solid var(--normal-color);
      }
    }
  }
`

export const SubSystemTagWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .ant-badge {
    cursor: default;
  }

  .ant-badge-status-text {
    margin-left: 6px;
    letter-spacing: var(--spacing-large);
  }

  .ant-badge-status-dot {
    /* 状态点动画 */
    &.ant-badge-status-loggerOffline::after,
    &.ant-badge-status-emergencyStop::after,
    &.ant-badge-status-failure::after,
    &.ant-badge-status-deviceOffline::after,
    &.ant-badge-status-shutDown::after,
    &.ant-badge-status-partShutDown::after,
    &.ant-badge-status-normal::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      animation: antStatusProcessing 1.2s infinite ease-in-out;
      content: '';
    }

    /* 通讯异常 */
    &.ant-badge-status-loggerOffline {
      background-color: var(--loggerOffline-color);
      &::after {
        border: 2px solid var(--loggerOffline-color);
      }
    }

    /* 紧急停止 */
    &.ant-badge-status-emergencyStop {
      background-color: var(--emergencyStop-color);
      &::after {
        border: 2px solid var(--emergencyStop-color);
      }
    }

    /* 故障 */
    &.ant-badge-status-failure {
      background-color: var(--failure-color);
      &::after {
        border: 2px solid var(--failure-color);
      }
    }

    /* 设备离线 */
    &.ant-badge-status-deviceOffline {
      background-color: var(--deviceOffline-color);
      &::after {
        border: 2px solid var(--deviceOffline-color);
      }
    }

    /* 停机 */
    &.ant-badge-status-shutDown {
      background-color: var(--shutDown-color);
      &::after {
        border: 2px solid var(--shutDown-color);
      }
    }

    /* 部分停机 */
    &.ant-badge-status-partShutDown {
      background-color: var(--partShutDown-color);
      &::after {
        border: 2px solid var(--partShutDown-color);
      }
    }
    
    /* 正常 */
    &.ant-badge-status-normal {
      background-color: var(--normal-color);
      &::after {
        border: 2px solid var(--normal-color);
      }
    }
  }
`

export const DefaultTagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .ant-tag {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    margin: 0;
    padding: 0;
    box-sizing: border-box;

    border: 1px solid var(--sky-light-285);
    border-radius: 24px !important;

    background: var(--white-100);
    box-shadow: none;

    color: var(--sky-25);
    font-size:  var(--fontsize-12);
    line-height: 1;
    letter-spacing: var(--spacing-large);

    width: calc(var(--wh-88) - var(--spacing-large));
    height: 24px;

    cursor: default;

    >span.ant-tag-status-text {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      padding: 0;
      box-sizing: border-box;

      font-size:  var(--fontsize-12);
      letter-spacing: var(--spacing-large);
      line-height: 1;
    }
  }
`

export const BlockedTagWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .ant-tag {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    margin: 0;
    padding: 0;
    box-sizing: border-box;

    border: 1px solid var(--sky-0);
    border-radius: 24px !important;

    background: var(--white-100);
    box-shadow: none;

    color: var(--sky-55);
    font-size:  var(--fontsize-12);
    line-height: 1;
    letter-spacing: var(--spacing-large);

    width: calc(var(--wh-98) - var(--spacing-large));
    height: 24px;

    cursor: default;

    // 去除点击后的涟漪动画效果
    &[ant-click-animating-without-extra-node]:after {
      border: 0 none;
      opacity: 0;
      animation: none 0 ease 0 1 normal;
    }

    &:hover {
      color: var(--sky-55);
      box-shadow: 0 0 8px var(--sky-5);
    }

    >span.ant-tag-status-text {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      padding: 0;
      box-sizing: border-box;

      font-size:  var(--fontsize-12);
      letter-spacing: var(--spacing-large);
      line-height: 1;
    }
  }
`

export const CommunicationStatusTagWrapper = styled.div`
  .ant-tag {
    margin-right: 0;
    padding: 0;
    white-space: nowrap;
    background: transparent;
    border: none;
   &.connection-failure {
    >.ant-tag-status-text {
      color: var(--communication-failure-color) !important;
      font-size: var(--fontsize-14);
    }
   }
   &.connection-success {
    >.ant-tag-status-text {
      color: var(--communication-normal-color) !important;
      font-size: var(--fontsize-14);
    }
   }
  }
`

export const ChargeStatusTagWrapper = styled.div`
  .ant-tag {
    padding: 0;
    margin-right: 0;
    white-space: nowrap;
    background: transparent;
    border: none;
   &.charging {
    >.ant-tag-status-text {
      color: var(--charging-color) !important;
      font-size: var(--fontsize-14);
    }
   }
   &.discharging {
    >.ant-tag-status-text {
      color: var(--discharging-color) !important;
      font-size: var(--fontsize-14);
    }
   }
  }
`

export const LightStausTagWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;

  .ant-tag {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;

    border: none;
    border-radius: 50%;
    box-sizing: border-box;

    color: var(--white-100);
    font-size: var(--fontsize-16);

    width: 52px;
    height: 52px;

    transition: var(--transition-normal);

    &.status-start {
      background: var(--start-color);
      box-shadow: 0 0 24px var(--start-light-color);
    }
    &.status-stop {
      background: var(--stop-color);
      box-shadow: 0 0 24px var(--stop-light-color);
    }
  }
`

export const RegulationResultTagWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: var(--wh-32);

  >.ant-typography {
    font-size: var(--fontsize-12);
  }

  .ant-tag {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: var(--gap-4);
    margin: 0;

    border: none;
    border-radius: 3px;
    box-sizing: border-box;

    .ant-typography {
      color: var(--white-100) !important;
    }

    min-width: var(--wh-58);
    height: var(--wh-16) !important;

    transition: var(--transition-normal);
    transform: var(--size-smaller);

    &.result-unqualified {
      background: var(--result-unqualified-color);
    }
    &.result-abnormal {
      background: var(--result-abnormal-color);
    }
  }
`

export const NoticeTypeTagWrapper = styled.div`
  .ant-tag {
    color: var(--white-100);
    border-radius: 2px;
    border: none;
  }
  .ant-tag-status-text {
    font-size: var(--fontsize-12);
    margin-left: 8px;
    color: var(--urgent);
  }
`